(function() {
  function updatePurchasePrice(area, qty) {
    var currentEl = area.querySelector('.purchase-area__current');
    var originalEl = area.querySelector('.purchase-area__original');
    var moneyFormat = area.dataset.moneyFormat;
    if (currentEl) {
      var unitPrice = parseInt(currentEl.dataset.unitPrice, 10) || 0;
      currentEl.textContent = window.catsightsFormatMoney(unitPrice * qty, moneyFormat);
    }
    if (originalEl) {
      var unitOriginal = parseInt(originalEl.dataset.unitOriginal, 10) || 0;
      if (unitOriginal) {
        originalEl.textContent = window.catsightsFormatMoney(unitOriginal * qty, moneyFormat);
      }
    }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;

    var area = btn.closest('[data-purchase-area]');
    if (!area) return;

    var valueEl = area.querySelector('[data-qty-value]');
    var inputEl = area.querySelector('[data-qty-input]');
    if (!valueEl || !inputEl) return;

    var qty = parseInt(valueEl.value, 10) || 1;
    if (btn.hasAttribute('data-qty-minus')) {
      qty = Math.max(1, qty - 1);
    } else {
      qty = qty + 1;
    }
    valueEl.value = qty;
    inputEl.value = qty;
    updatePurchasePrice(area, qty);
    area.dispatchEvent(new CustomEvent('purchase:qty-changed', { bubbles: true }));

    var stickySection = area.closest('[data-section-id]');
    var stickyForm = stickySection
      ? stickySection.querySelector('[id*="product-sticky-form"]')
      : document.getElementById('product-sticky-form');
    if (stickyForm) {
      var stickyQty = stickyForm.querySelector('input[name="quantity"]');
      if (stickyQty) stickyQty.value = qty;
    }
  });

  document.addEventListener('input', function(e) {
    var input = e.target.closest('[data-qty-value]');
    if (!input) return;

    var area = input.closest('[data-purchase-area]');
    if (!area) return;

    var qty = parseInt(input.value, 10);
    if (!qty || qty < 1) return;

    var hiddenInput = area.querySelector('[data-qty-input]');
    if (hiddenInput) hiddenInput.value = qty;
    updatePurchasePrice(area, qty);
    area.dispatchEvent(new CustomEvent('purchase:qty-changed', { bubbles: true }));

    var stickySection = area.closest('[data-section-id]');
    var stickyForm = stickySection
      ? stickySection.querySelector('[id*="product-sticky-form"]')
      : document.getElementById('product-sticky-form');
    if (stickyForm) {
      var stickyQty = stickyForm.querySelector('input[name="quantity"]');
      if (stickyQty) stickyQty.value = qty;
    }
  });

  document.addEventListener('blur', function(e) {
    var input = e.target.closest('[data-qty-value]');
    if (!input) return;

    var val = parseInt(input.value, 10);
    if (!val || val < 1) {
      var area = input.closest('[data-purchase-area]');
      input.value = 1;
      if (area) {
        var hiddenInput = area.querySelector('[data-qty-input]');
        if (hiddenInput) hiddenInput.value = 1;
        updatePurchasePrice(area, 1);
        area.dispatchEvent(new CustomEvent('purchase:qty-changed', { bubbles: true }));

        var section = area.closest('[data-section-id]');
        var stickyForm = section
          ? section.querySelector('[id*="product-sticky-form"]')
          : document.getElementById('product-sticky-form');
        if (stickyForm) {
          var stickyQty = stickyForm.querySelector('input[name="quantity"]');
          if (stickyQty) stickyQty.value = '1';
        }
      }
    }
  }, true);
})();
